import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-multi-validation-modal',
  templateUrl: './multi-validation-modal.component.html',
  styleUrls: ['./multi-validation-modal.component.less']
})
export class MultiValidationModalComponent implements OnInit {

  @Input() expectedObj: any ;
  @Input() actualObj: any;

  multipleResults: any ;

  constructor() { }

  ngOnInit() {
    this.createModalContent();
  }

  createModalContent(): void {
    let expectedVal = [];
    if (!this.expectedObj.isExtracted) {
      expectedVal.push({
        extractedValue: this.expectedObj.value
      });
    } else {
      expectedVal = this.expectedObj.responseExtractor.responseExtractorResult;
    }
    this.multipleResults = {
      expectedObj: expectedVal,
      actualObj: this.actualObj
    };
  }
}
